import { LoadingLargeSvg, LoadingSvg } from '../wf-svg';

import './index.scss';

interface WfLoadingProps {
  size?: 'medium' | 'large';
}

function WfLoading(props: WfLoadingProps) {
  const { size = 'medium' } = props;

  const isLarge = size === 'large';

  const loadingIconClassName = `wf-loading-icon ${isLarge ? 'wf-loading-icon_large' : ''}`;

  return (
    <div className="wf-loading-container">
      {isLarge ? <LoadingLargeSvg className={loadingIconClassName} /> : <LoadingSvg className={loadingIconClassName} />}
    </div>
  );
}

export default WfLoading;
